<div class="nav-header navbar fixed-top desktop">
    <div class="container ">
        <a routerLink="" class="navbar-brand">
            <img src="../../assets/images/Logo.jpg" class="logo d-block"/>
        </a>
        <ul class="nav nav-header-items f-roboto ">
            <li class="nav-item"><a routerLink="" class="d-block pe-4 menu-a">Inicio</a></li>
            <li class="nav-item dropdown" ngbDropdown>
                <a class="d-block px-3 dropdown-toggle menu-a" ngbDropdownToggle id="dropdownServicios">
                  Camiones
                </a>
                <ul ngbDropdownMenu aria-labelledby="dropdownServicios" class="dropdown-menu mt-4">
                  <li *ngFor="let items of modelos"><a [routerLink]="items.modelo_url" class="dropdown-item color-red py-2">{{items.nombre_modelo}}</a></li>
                </ul>
            </li>
            <li class="nav-item"><a routerLink="sobre-nosotros" class="b-block px-4 menu-a">Sobre Nosotros</a></li>
            <li class="nav-item"><a routerLink="sucursales" class="b-block px-4 menu-a">Sucursales</a></li>
            <li class="nav-item"><a routerLink="contactenos" class="b-block ps-3 menu-a">Contacto</a></li>
        </ul>
    </div>
</div>
<app-mobile class="mobile"></app-mobile>